<template>
    <div class="login-panel info-panel" v-if="beforeDate('2025-08-31')">
        <div class="info-text">
            <h4>
                <md-icon class="text-warning">info</md-icon>
            </h4>
            <b class="md-color-orange">Customer Notice</b>
            <p>In response to feedback on customer preferences when requesting support, we have discontinued the Support Team telephone line.</p>
            <p>You can reach us faster through our in-platform Live Chat or by emailing <a href="mailto:supportteam@navitassafety.com">supportteam@navitassafety.com</a>. You can also request a callback through these channels.</p>
            <p>Rest assured, this change does not affect other phone lines or customer SLAs.</p>
            <p>Best wishes,<br />Navitas Safety Team</p>
        </div>
    </div>
</template>

<script>

    export default {
        name: "LoginNotice",
        methods: {
            beforeDate: function (to_date) {
                return (new Date()) < (new Date(to_date))
            },
            betweenDates: function (from_date, to_date) {
                return ((new Date()) >= (new Date(from_date))) && (new Date()) <= ((new Date(to_date)));
            },
        }
    }
</script>